import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import Navbar from "../components/Nav.jsx";
import Overview from "../Overview";
import LoginGuide from "../Guides/LoginGuide";
import UpdateGuide from "../Guides/UpdateGuide";
import ForgotGuide from "../Guides/ForgotGuide";
import CalcGuide from "../Guides/CalcGuide";
import RegionGuide from "../Guides/RegionGuide";
import WelcomeGuide from "../Guides/WelcomeGuide";
import CalcStepGuide from "../Guides/CalcStepGuide";
import FieldStepGuide from "../Guides/FieldStepGuide";
import HetFieldGuide from "../Guides/HetFieldGuide";
import OverrideGuide from "../Guides/OverrideGuide";
import AnalyticsGuide from "../Guides/AnalyticsGuide";
import FineTuneGuide from "../Guides/FineTuneGuide";
import CostGuide from "../Guides/CostGuide";
import CPPGuide from "../Guides/CPPGuide";
import SensitivityGuide from "../Guides/SensitivityGuide";
import MatrixGuide from "../Guides/MatrixGuide";
import ReportGenGuide from "../Guides/ReportGenGuide";
import MyReportGuide from "../Guides/MyReportGuide";
import InsightsGuide from "../Guides/InsightsGuide";

const contentType = {
  ALLOC_NONE: 0,
  OVERVIEW: 1,
  LOGIN_GUIDE: 3,
  UPDATE_GUIDE: 4,
  FORGOT_GUIDE: 5,
  CALC_GUIDE: 6,
  REGION_GUIDE: 7,
  WELCOME_GUIDE: 8,
  CALC_STEP_GUIDE: 9,
  FIELD_STEP_GUIDE: 10,
  HET_FIELD_GUIDE: 11,
  OVERRIDE_GUIDE: 12,
  ANALYTICS_GUIDE: 13,
  FINE_TUNE_GUIDE: 14,
  COST_GUIDE: 15,
  CPP_GUIDE: 16,
  SENSITVITY_GUIDE: 17,
  MATRIX_GUIDE: 18,
  REPORT_GEN_GUIDE: 19,
  MY_REPORT_GUIDE: 20,
  INSIGHTS_GUIDE: 21,
};

const Guide = () => {
  const [selectedContent, setSelectedContent] = useState(contentType.OVERVIEW);

  const renderGuideContent = () => {
    switch (selectedContent) {
      case contentType.OVERVIEW:
        return <Overview />;
      case contentType.LOGIN_GUIDE:
        return <LoginGuide />;
      case contentType.UPDATE_GUIDE:
        return <UpdateGuide />;
      case contentType.FORGOT_GUIDE:
        return <ForgotGuide />;
      case contentType.CALC_GUIDE:
        return <CalcGuide />;
      case contentType.REGION_GUIDE:
        return <RegionGuide />;
      case contentType.WELCOME_GUIDE:
        return <WelcomeGuide />;
      case contentType.CALC_STEP_GUIDE:
        return <CalcStepGuide />;
      case contentType.FIELD_STEP_GUIDE:
        return <FieldStepGuide />;
      case contentType.HET_FIELD_GUIDE:
        return <HetFieldGuide />;
      case contentType.OVERRIDE_GUIDE:
        return <OverrideGuide />;
      case contentType.ANALYTICS_GUIDE:
        return <AnalyticsGuide />;
      case contentType.FINE_TUNE_GUIDE:
        return <FineTuneGuide />;
      case contentType.COST_GUIDE:
        return <CostGuide />;
      case contentType.CPP_GUIDE:
        return <CPPGuide />;
      case contentType.SENSITVITY_GUIDE:
        return <SensitivityGuide />;
      case contentType.MATRIX_GUIDE:
        return <MatrixGuide />;
      case contentType.REPORT_GEN_GUIDE:
        return <ReportGenGuide />;
      case contentType.MY_REPORT_GUIDE:
        return <MyReportGuide />;
      case contentType.INSIGHTS_GUIDE:
        return <InsightsGuide />;
      default:
        return "ERROR";
    }
  };

  sessionStorage.setItem("reportStatus", "false");

  // helper to apply active color
  const itemStyle = (type) => ({
    color: selectedContent === type ? "#5197F7" : "#ABA9A5",
    cursor: "pointer",
  });
  // NEW: helper to check if group has an active child
const groupStyle = (groupTypes) => ({
    color: groupTypes.includes(selectedContent) ? "#5197F7" : "#ABA9A5",
    cursor: "pointer",
  });

  return (
    <>
      <Navbar />
      <div className="container-form max-screen-width ">
        <div className="row  ">
          <div className="col page-container">
            <div id="faq-header">
              <p className="font-32 font-semi-bold">"How To" Guide</p>
            </div>
            <Row id="guide-container">
              {/* Sidebar */}
              <Col
                md="4"
                id="guide-sidebar"
                className="d-flex flex-column gap-20"
              >
                {/* Overview */}
                <div
                  className="p-2 guide-item"
                  style={itemStyle(contentType.OVERVIEW)}
                  onClick={() => setSelectedContent(contentType.OVERVIEW)}
                >
                  <p className="font-semi-bold toUpper">Overview</p>
                </div>

                {/* Getting Started */}
                <div className="d-flex justify-content-between align-items-center">
                  <span
                    className="sidebar-heading font-semi-bold toUpper"
                    // style={itemStyle(contentType.LOGIN_GUIDE)}
                    style={groupStyle([
                        contentType.LOGIN_GUIDE,
                        contentType.UPDATE_GUIDE,
                        contentType.FORGOT_GUIDE,
                      ])}
                  >
                    Getting Started
                  </span>
                  <img src="/assets/arrow-right.svg" alt="" />
                </div>
                <div
                  className="p-2 pl-4 guide-item"
                  style={itemStyle(contentType.LOGIN_GUIDE)}
                  onClick={() => setSelectedContent(contentType.LOGIN_GUIDE)}
                >
                  <p className="font-semi-bold">• Login</p>
                </div>
                <div
                  className="p-2 pl-4 guide-item"
                  style={itemStyle(contentType.UPDATE_GUIDE)}
                  onClick={() => setSelectedContent(contentType.UPDATE_GUIDE)}
                >
                  <p className="font-semi-bold">• Update Password</p>
                </div>
                <div
                  className="p-2 pl-4 guide-item"
                  style={itemStyle(contentType.FORGOT_GUIDE)}
                  onClick={() => setSelectedContent(contentType.FORGOT_GUIDE)}
                >
                  <p className="font-semi-bold">• Forgot Password</p>
                </div>

                {/* How To Guide */}
                <div className="d-flex justify-content-between align-items-center">
                  <p
                    className="sidebar-heading font-semi-bold toUpper"
                    style={itemStyle(contentType.CALC_GUIDE)}
                  >
                    How To Guide
                  </p>
                  <img src="/assets/arrow-right.svg" alt="" />
                </div>
                <div
                  className="p-2 pl-4 guide-item"
                  style={itemStyle(contentType.CALC_GUIDE)}
                  onClick={() => setSelectedContent(contentType.CALC_GUIDE)}
                >
                  <p className="font-semi-bold">• Calculator</p>
                </div>
                <div
                  className="p-2 pl-5 guide-item"
                  style={itemStyle(contentType.REGION_GUIDE)}
                  onClick={() => setSelectedContent(contentType.REGION_GUIDE)}
                >
                  <p className="font-semi-bold">1. Region Selection</p>
                </div>
                <div
                  className="p-2 pl-5 guide-item"
                  style={itemStyle(contentType.WELCOME_GUIDE)}
                  onClick={() => setSelectedContent(contentType.WELCOME_GUIDE)}
                >
                  <p className="font-semi-bold">2. Welcome Screen</p>
                </div>
                <div
                  className="p-2 pl-5 guide-item"
                  style={itemStyle(contentType.CALC_STEP_GUIDE)}
                  onClick={() =>
                    setSelectedContent(contentType.CALC_STEP_GUIDE)
                  }
                >
                  <p className="font-semi-bold">
                    3. Calculator Step Navigation
                  </p>
                </div>
                <div
                  className="p-2 pl-5 guide-item"
                  style={itemStyle(contentType.FIELD_STEP_GUIDE)}
                  onClick={() =>
                    setSelectedContent(contentType.FIELD_STEP_GUIDE)
                  }
                >
                  <p className="font-semi-bold">4. Text fields and Dropdowns</p>
                </div>
                <div
                  className="p-2 pl-5 guide-item"
                  style={itemStyle(contentType.HET_FIELD_GUIDE)}
                  onClick={() =>
                    setSelectedContent(contentType.HET_FIELD_GUIDE)
                  }
                >
                  <p className="font-semi-bold">
                    5. Heterogeneous Layout Fields
                  </p>
                </div>
                <div
                  className="p-2 pl-5 guide-item"
                  style={itemStyle(contentType.OVERRIDE_GUIDE)}
                  onClick={() => setSelectedContent(contentType.OVERRIDE_GUIDE)}
                >
                  <p className="font-semi-bold">
                    6. Override & Personalization
                  </p>
                </div>

                {/* Analytics */}
                <div
                  className="p-2 pl-4 guide-item"
                  style={itemStyle(contentType.ANALYTICS_GUIDE)}
                  onClick={() =>
                    setSelectedContent(contentType.ANALYTICS_GUIDE)
                  }
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="font-semi-bold">• Visual Analytics</span>
                    <img src="/assets/arrow-right.svg" alt="" />
                  </div>
                </div>
                <div
                  className="p-2 pl-5 guide-item"
                  style={itemStyle(contentType.FINE_TUNE_GUIDE)}
                  onClick={() =>
                    setSelectedContent(contentType.FINE_TUNE_GUIDE)
                  }
                >
                  <p className="font-semi-bold">1. Fine Tune Scenario</p>
                </div>
                <div
                  className="p-2 pl-5 guide-item"
                  style={itemStyle(contentType.COST_GUIDE)}
                  onClick={() => setSelectedContent(contentType.COST_GUIDE)}
                >
                  <p className="font-semi-bold">
                    2. Cost Distribution & Build Cost Per Part
                  </p>
                </div>
                <div
                  className="p-2 pl-5 guide-item"
                  style={itemStyle(contentType.SENSITVITY_GUIDE)}
                  onClick={() =>
                    setSelectedContent(contentType.SENSITVITY_GUIDE)
                  }
                >
                  <p className="font-semi-bold">3. Sensitivity Graphs</p>
                </div>
                <div
                  className="p-2 pl-5 guide-item"
                  style={itemStyle(contentType.MATRIX_GUIDE)}
                  onClick={() => setSelectedContent(contentType.MATRIX_GUIDE)}
                >
                  <p className="font-semi-bold">4. Cost Matrix</p>
                </div>

                {/* Reports */}
                <div
                  className="p-2 pl-4 guide-item"
                  style={itemStyle(contentType.REPORT_GEN_GUIDE)}
                  onClick={() =>
                    setSelectedContent(contentType.REPORT_GEN_GUIDE)
                  }
                >
                  <p className="font-semi-bold">• Report Generation</p>
                </div>
                <div
                  className="p-2 pl-4 guide-item"
                  style={itemStyle(contentType.MY_REPORT_GUIDE)}
                  onClick={() =>
                    setSelectedContent(contentType.MY_REPORT_GUIDE)
                  }
                >
                  <p className="font-semi-bold">• My Reports</p>
                </div>

                {/* Insights */}
                <div
                  className="p-2 pl-4 guide-item"
                  style={itemStyle(contentType.INSIGHTS_GUIDE)}
                  onClick={() => setSelectedContent(contentType.INSIGHTS_GUIDE)}
                >
                  <p className="font-semi-bold">• Insights</p>
                </div>
              </Col>

              {/* Main content */}
              <Col md="8" id="guide-details">
                {renderGuideContent()}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default Guide;
